import { render, staticRenderFns } from "./AUserHeader.vue?vue&type=template&id=04432990&scoped=true"
import script from "./AUserHeader.vue?vue&type=script&lang=js"
export * from "./AUserHeader.vue?vue&type=script&lang=js"
import style0 from "./AUserHeader.vue?vue&type=style&index=0&id=04432990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04432990",
  null
  
)

export default component.exports